import toInt from "@/core/util/toInt";

export function toID(id: any) {
    return toInt(id)
}

